module.exports = __webpack_public_path__ + "static/media/wind-mill-blue.4dce46f8.svg";